import { Station } from '@mi-front/core';

import { useStationsFinder } from '../stations/hooks/useStations';

export function useStationsQueryParamParser() {
  const finder = useStationsFinder();

  return {
    parse: (input: string) =>
      input
        .split(',')
        .map(finder)
        .filter((value): value is Station => !!value),
    serialize: (stations: Station[]) => stations.map((s) => s.id).join(','),
  };
}
